import React from 'react';
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="bg-slate-900 py-24 relative overflow-hidden">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 opacity-20 pointer-events-none">
        <svg width="800" height="800" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="400" cy="400" r="399" stroke="white" strokeWidth="1"/>
          <circle cx="400" cy="400" r="300" stroke="white" strokeWidth="1" strokeDasharray="10 10"/>
          <circle cx="400" cy="400" r="200" stroke="white" strokeWidth="1"/>
          <line x1="0" y1="400" x2="800" y2="400" stroke="white" strokeWidth="0.5" />
          <line x1="400" y1="0" x2="400" y2="800" stroke="white" strokeWidth="0.5" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-6">
          Ready to transform your organization?
        </h2>
        <p className="text-xl text-slate-300 mb-10 font-light max-w-2xl mx-auto">
          Connect with our partners to discuss how Eldenwyck & Co. can help you achieve your most critical objectives.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/contact" onClick={() => window.scrollTo(0,0)} className="bg-amber-600 text-white px-8 py-4 font-semibold hover:bg-amber-500 transition-all active:scale-95 shadow-lg shadow-amber-600/20">
            Contact a Partner
          </Link>
          <Link to="/locations" onClick={() => window.scrollTo(0,0)} className="bg-transparent border border-white/30 text-white px-8 py-4 font-semibold hover:bg-white hover:text-slate-900 transition-all active:scale-95">
            Find an Office
          </Link>
        </div>
      </div>
    </section>
  );
}